<template>
  <div style="margin-bottom: 100px">
    <ed-alert
      title="Atenção"
      type="warning"
      description="Os Fatores de Riscos listados abaixo devem ser vinculados aos riscos mostrados em Configurações > Riscos"
      class="mb-2"
    />

    <TableView
      registerName="Inserir Fator de Risco"
      :onRegister="onRegister"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :onSearch="getFatorRisco"
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :pagination="pagination"
      :response="response"
			:onFilter="getFatorRisco"
      :filterBadge="filterBadge"
    >
      <div slot="table-export">
        <ed-button
          icon="fa fa-download"
          type="text"
          value="Exportar para Excel"
          title="Clique aqui para exportar os dados para excel"
          @click="onExcel"
        />
      </div>

			 <div slot="table-filter-content">
					<ed-form>
						  <ed-input-select-tipo
								class="col-12"
								label="Filtrar por Categopria"
								name="cat_esocial"
								tipo="269"
								valueKey="descricao"
								v-model="formFilter.cat_esocial"
								multiple
							/>
					</ed-form>
				</div>
    </TableView>
  </div>
</template>

<script>
import TableView from "common/table";
import Rest from "common/rest";
import EdButton from "common/button";
import EdAlert from "common/alert";
import {EdForm,EdInputSelectTipo} from 'template';

export default {
  name: "exame",
  components: { TableView, EdAlert, EdButton,EdForm,EdInputSelectTipo },
  mixins: [Rest],
  data() {
    return {
      formData: {
        id: 0,
        nome: null,
        tuss: null,
        interpr: null,
        ordem: null,
        ex_id_min: null,
        ex_id_max: null,
        tipo: null,
        proprio: null,
      },
			formFilter:{
				cat_esocial:[]
			},
      pagination: {},
      response: {},
			filterBadge:0,
      tableHead: [
        {
          key: "id",
          sortable: true,
          label: "CÓD",
        },
        {
          key: "nome",
          sortable: true,
          label: "Nome",
        },
        {
          key: "cat_esocial",
          sortable: true,
          label: "CATEGORIA",
        },
        {
          key: "cod_metodologia",
          sortable: true,
          label: "CÓD METODOLOGIA",
        },
        {
          key: "cod_esocial",
          sortable: true,
          label: "CÓD ESOCIAL",
        },
        {
          key: "cas",
          sortable: true,
          label: "CÓD CAS",
        },
        {
          key: "ativo",
          sortable: true,
          label: "Ativo",
        },
      ],
      tableData: [],
      loadingTable: false,
      showFormEdit: false,
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },
  created() {},

  mounted: function () {
    this.getFatorRisco();
  },

  methods: {
    onExcel() {
      this.open("fator-risco/excel", { filter: {} });
    },

    onRegister: function () {
      this.toRoute({ name: "ltcat.risco.cadastrar" });
    },

    onEdit: function (data) {
      this.toRoute({ name: "ltcat.risco.editar", params: { id: data.id } });
    },

    onDelete: function (data) {
      var self = this;

      this.$confirm(
        "O sistema vai excluir " +
          data.length +
          " registro(s). Deseja prosseguir?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        self.loadingEditAll = true;

        this.post("/fator-risco/deletar", { ids: data }).then((result) => {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getFatorRisco();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    getFatorRisco(_search, _page, _pagination) {
      this.loadingTable = true;
      this.response = {};

			this.filterBadge = this.formFilter.cat_esocial.length;

      this.get("fator-risco", {
        search: _search,
        page: _page,
        pagination: _pagination,
				filter:this.formFilter
      }).then((result) => {
        result = result[0];
        this.response = result;

        if (result.status == 200) {
          var data = result.data.data,
            tableData = [],
            pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cas: data[i].cod_cas,
							cat_esocial: data[i].cat_esocial,
              cod_metodologia: data[i].cod_metodologia,
              cod_esocial: data[i].cod_esocial,
              ativo: data[i].ativo == 1 ? "Sim" : "Não",
              _data: data[i],
              options: {
                disable_delete: !this.validarPermissao(568),
                disable_edit: !this.validarPermissao(568),
              },
              buttons: [],
            };

            tableData.push(item);
          }

          this.pagination = pagination;
          this.tableData = tableData;
          this.loadingTable = false;
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// index.vue?2d53e7fe